import React from 'react'
import {useLocation, useNavigate} from 'react-router-dom'
import TabsWrappedLabel from 'src/v2/components/tabs/tabs-component'
import {Box} from '@mui/material'
import {
    MOTOR_EVENTOS_PARAMETROS,
    MOTOR_EVENTOS_ORDINARIOS,
    MOTOR_EVENTOS_EXTRAORDINARIOS,
    MOTOR_EVENTOS_VALIDACAO
} from 'src/utils/routes'

function FluxoTabs() {
    const location = useLocation()
    const navigate = useNavigate()

    const getCurrentTab = () => {
        const path = location.pathname

        if (path.includes(MOTOR_EVENTOS_ORDINARIOS)) return 'ordinarios'
        if (path.includes(MOTOR_EVENTOS_EXTRAORDINARIOS)) return 'extraordinarios'
        if (path.includes(MOTOR_EVENTOS_VALIDACAO)) return 'validacao'

        return 'parametros'
    }

    const handleTabChange = (event, newValue) => {
        const currentState = location.state || {}

        switch (newValue) {
            case 'parametros':
                navigate(MOTOR_EVENTOS_PARAMETROS, {state: currentState})
                break
            case 'ordinarios':
                navigate(MOTOR_EVENTOS_ORDINARIOS, {state: currentState})
                break
            case 'extraordinarios':
                navigate(MOTOR_EVENTOS_EXTRAORDINARIOS, {state: currentState})
                break
            case 'validacao':
                navigate(MOTOR_EVENTOS_VALIDACAO, {state: currentState})
                break
            default:
                break
        }
    }

    const tabsData = [
        {value: 'parametros', label: 'PARÂMETROS', content: null},
        {value: 'ordinarios', label: 'EVENTOS ORDINÁRIOS', content: null},
        {value: 'extraordinarios', label: 'EVENTOS EXTRAORDINÁRIOS', content: null},
        {value: 'validacao', label: 'VALIDAÇÃO', content: null},
    ]

    return (
        <Box sx={{
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'flex-end',
            alignItems: 'center',
            backgroundColor: 'background.paper',
        }}>
            <TabsWrappedLabel
                tabs={tabsData}
                value={getCurrentTab()}
                onChange={handleTabChange}
            />
        </Box>
    )
}

export default FluxoTabs